import {Box, Skeleton, Stack} from "@mui/material";

export interface BmTableSkeletonProps {
  rows?: number;
  cells?: number;
}

export const BmTableSkeleton: React.FC<BmTableSkeletonProps> = ({rows = 4, cells = 3}) => (
  <Stack spacing={1}>
    {Array.from({length: rows}, (_, i) => (
      <Box key={i} sx={{display: "flex", alignItems: "center", gap: 2, py: 1, px: 1, borderRadius: 2}}>
        {Array.from({length: cells}, (_, j) => (
          <Skeleton key={j} variant="rounded" height={25} sx={{flex: 1, borderRadius: 2}} />
        ))}
      </Box>
    ))}
  </Stack>
);
